import { render } from "./ImgSwiper.vue?vue&type=template&id=0aae5cc4&scoped=true"
import script from "./ImgSwiper.vue?vue&type=script&lang=js"
export * from "./ImgSwiper.vue?vue&type=script&lang=js"

import "./ImgSwiper.vue?vue&type=style&index=0&id=0aae5cc4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0aae5cc4"

export default script